<template>
  <div class="headerNav" :class="ispadding ? 'pad_btm' : ''">
    <div class="all">
      <div class="container">
        <div class="icons" v-if="showType">
          <p class="typeicon">
            <img
              class="img"
              src="../../assets/sushi_icon.png"
              :alt="$t('productList.vegetarian')"
              :title="$t('productList.vegetarian')"
              @click.stop="toCategory(6)"
            />
            <img
              class="img"
              src="../../assets/youji_icon.png"
              :alt="$t('productList.organic')"
              :title="$t('productList.organic')"
              @click.stop="toCategory(1)"
            />
            <img
              class="img"
              src="../../assets/wufu_icon.png"
              :alt="$t('productList.glutenFree')"
              :title="$t('productList.glutenFree')"
              @click.stop="toCategory(5)"
            />
            <img
              class="img last"
              src="../../assets/qingzhen_icon.png"
              :alt="$t('productList.muslim')"
              :title="$t('productList.muslim')"
              @click.stop="toCategory(2)"
            />

            <img
              class="img last"
              src="../../assets/nosugar.png"
              :alt="$t('productList.nosugar')"
              :title="$t('productList.nosugar')"
              @click.stop="toCategory(4)"
            />
          </p>
        </div>
        <!-- 活动 暂时隐藏   活动下架  v-if="false" 删除即可 -->
        <div class="clogo" >
          <h1 class="logo_zh" v-if="lang == 1">
            <img src="../../assets/logo_zh.png" alt @click.stop="goIndex()" />
          </h1>
          <h1 class="logo" v-else>
            <img
              class="logoimg"
              src="../../assets/logo.png"
              alt
              @click.stop="goIndex()"
            />
          </h1>
        </div>

        <div class="fr" v-if="showPerson">
          <div class="private">
            <p class="personicon">
              <span
                class="item me"
                @mouseover.stop="enter(true)"
                @mouseleave="leave(false)"
                style="width: 100px"
              >
                <span v-if="token && allinfo != 0" :class="['menum']">{{
                  allinfo == 0 ? "" : allinfo
                }}</span>

                <img
                  class="img person"
                  v-if="token"
                  src="../../assets/person_icon_logined.png"
                  alt=""
                  @click="personCenter"
                />
                <img
                  class="img person"
                  v-else
                  src="../../assets/person_icon.png"
                  alt=""
                  @click="personCenter"
                />
                <p v-if="token" @click="personCenter">{{ trueName }}</p>
                <p v-else style="width: 150px; margin-left: -25px">
                  <span @click="goLogin">{{ $t("headerNav.login") }}</span>
                  /
                  <span @click="toRegister">{{
                    $t("headerNav.register")
                  }}</span>
                </p>
                <span
                  :class="[
                    { arrow_mecn: lang == 1 },
                    { arrow_meen: lang == 2 },
                    { arrow_mefr: lang == 3 && !token },
                    { arrow_nologin: lang == 3 && token },
                  ]"
                ></span>
              </span>
              <span class="item" @click="goUserCenter('/user/onlineRecharge')">
                <img
                  class="img chongzhi"
                  src="../../assets/chongzhi_icon.png"
                  alt
                />
                <p>{{ $t("headerNav.topUp") }}</p>
              </span>
              <span class="item" @click="goUserCenter('/user/invitation')">
                <img class="img refer" src="../../assets/refer_icon.png" alt />
                <p>{{ $t("headerNav.refer_friend") }}</p>
              </span>
            </p>
            <!-- 未登录 -->
            <div
              :class="{
                login_dialog: lang == 1,
                login_dialog_en: lang == 2,
                login_dialog_fr: lang == 3,
              }"
              v-if="loginDialog"
            >
              <span class="login_whitearrow"></span>
              <span class="login_greenarrow"></span>
              <p class="closeLogin" @click="closeLoginDialog">
                <img src="../../assets/close-quick.png" alt />
              </p>
              <p>
                <input
                  type="text"
                  class="login-account"
                  v-model.trim="account"
                  :placeholder="$t('login.placeholder_account')"
                />
              </p>
              <p>
                <input
                  type="password"
                  class="login-password"
                  v-model="password"
                  autocomplete="new-password"
                  :placeholder="$t('login.placeholder_pass')"
                />
              </p>
              <p class="forgetPwd" @click="forgetPwd">
                {{ $t("login.forgetPass") }}
              </p>
              <p class="loginBtn" @click="Login">{{ $t("headerNav.login") }}</p>
              <p class="registerBtn" @click="toRegister">
                {{ $t("headerNav.register") }}
              </p>
            </div>
            <!-- 登录后显示会员中心 -->
            <!-- v-if="isPerson && token" -->
            <div
              :class="{
                quick_person: lang == 1,
                quick_person_en: lang == 2,
                quick_person_fr: lang == 3,
              }"
              @mouseenter="enter(true)"
              @mouseleave="leave(false)"
              v-if="isPerson && token"
            >
              <!-- <span :class="['white_arrow',{'en':lang == 2},{'fr':lang == 3}]"></span>
              <span :class="['green_arrow',{'en': lang == 2},{'fr':lang == 3}]"></span>-->

              <span class="green_arrow">
                <img src="../../assets/icon/header/mem_arrow.png" />
              </span>
              <p class="close" @click="closePerson(false)">
                <img src="../../assets/close-quick.png" alt />
              </p>
              <div class="memberInfo">
                 <p class="grade">
                  <img
                    v-if="cusInfo.CusLevelID == 3"
                    class="gradeimg_3"
                    src="../../assets/icon/user/level_3.png"
                    alt
                  />
                  <img
                    v-if="cusInfo.CusLevelID == 5"
                    class="gradeimg_5"
                    src="../../assets/icon/user/level_5.png"
                    alt
                  />
                  <img
                    v-if="cusInfo.CusLevelID == 9"
                    class="gradeimg_9"
                    src="../../assets/icon/user/level_9.png"
                    alt
                  />
                  <span
                    v-if="cusInfo.CusLevelID == 3"
                    class="level-name"
                  >{{$t("headerNav.level_3")}}</span>
                  <span
                    v-if="cusInfo.CusLevelID == 5"
                    class="level-name"
                  >{{$t("headerNav.level_5")}}</span>
                  <span
                    v-if="cusInfo.CusLevelID == 9"
                    class="level-name"
                  >{{$t("headerNav.level_9")}}</span>
                </p>
                <!-- 
                <p class="points">
                  {{$t("headerNav.points")}}:&nbsp;&nbsp;
                  <span class="num" @click.stop="goPoint()">{{cusInfo.Points}}</span>
                </p> -->
                <p class="account clearfix">
                  <span class="fl">
                    {{ $t("headerNav.balance") }}:&nbsp;&nbsp;
                    <span class="num" @click.stop="goAccount()"
                      >￥{{ cusInfo.Balance }}</span
                    >
                  </span>
                  <span class="logout fr" @click.stop="logout()">{{
                    $t("headerNav.logout")
                  }}</span>
                </p>
              </div>
              <div class="personal clearfix">
                <p class="item_p fl" @click="referFriend">
                  <router-link to="/user/invitation">
                    <img
                      class="refer"
                      src="../../assets/icon/header/C_Share.png"
                      alt
                    />
                    <span>{{ $t("headerNav.refer_friend2") }}</span>
                  </router-link>
                </p>
                <p
                  :class="['item_p', 'fl', 'item_pen2']"
                  @click="closePerson(false)"
                >
                  <router-link to="/user/orderLetter">
                    <img
                      class="letter"
                      src="../../assets/icon/header/C_Letter.png"
                      alt
                    />
                    <span>{{ $t("headerNav.message") }}</span>
                    <span
                      v-if="cusInfo.UnreadQuantity != 0"
                      :class="[
                        'letterNum',
                        { zh: lang == 1 },
                        { fr: lang == 3 },
                      ]"
                      >{{ cusInfo.UnreadQuantity }}</span
                    >
                  </router-link>
                </p>
                <p class="item_p fl" @click="closePerson(false)">
                  <router-link to="/user/keepList">
                    <img
                      class="like"
                      src="../../assets/icon/header/C_Collection.png"
                      alt
                    />
                    <span>{{ $t("headerNav.like") }}</span>
                  </router-link>
                </p>
                <p class="item_p fl" @click="closePerson(false)">
                  <router-link to="/user/userInfo">
                    <img
                      class="person"
                      src="../../assets/icon/header/M_user.png"
                      alt
                    />
                    <span>{{ $t("headerNav.Information") }}</span>
                  </router-link>
                </p>
                <p
                  :class="['item_p', 'fl', 'item_pen5']"
                  @click="closePerson(false)"
                >
                  <router-link to="/user/getOrdersList">
                    <img
                      class="order"
                      src="../../assets/icon/header/C_Order.png"
                      alt
                    />
                    <span>{{ $t("headerNav.order") }}</span>
                  </router-link>
                </p>
                <p class="item_p fl" @click="closePerson(false)">
                  <router-link to="/user/accountDetails">
                    <img
                      class="wallet"
                      src="../../assets/icon/header/C_wellet.png"
                      alt
                    />
                    <span>{{ $t("headerNav.wallet") }}</span>
                  </router-link>
                </p>

                <p class="item_p fl" @click="closePerson(false)">
                  <router-link to="/user/coupon">
                    <img
                      class="person"
                      src="../../assets/icon/header/coup.png"
                      alt
                    />
                    <span>{{ $t("headerNav.cop") }}</span>
                    <span
                      v-if="cusInfo.CashVoucherList != 0"
                      :class="[
                        'letterNum',
                        { zh: lang == 1 },
                        { fr: lang == 3 },
                      ]"
                      >{{ cusInfo.CashVoucherList }}</span
                    >
                  </router-link>
                </p>

                <p class="item_p fl" @click="closePerson(false)">
                  <router-link to="/user/onlineRecharge">
                    <img
                      class="person"
                      src="../../assets/icon/header/chongzhi.png"
                      alt
                    />
                    <span>{{ $t("headerNav.chong") }}</span>
                  </router-link>
                </p>
              </div>
              <!-- v-if="RegularProducts" -->
              <div class="necessity" v-if="RegularProducts">
                <div class="title clearfix">
                  <span class="text">{{ $t("headerNav.necessity") }}</span>
                </div>
                <div class="goods clearfix">
                  <div
                    class="goodsItem fl"
                    v-for="(goods, index) in RegularProducts"
                    :key="index"
                    @click.stop="toDetail(goods)"
                  >
                    <div class="pic">
                      <div class="low-price" v-if="goods.isLowPrice == true">
                        <img
                          src="../../assets/icon/product-icon/icon_ch_en1.png"
                          class="ch_img"
                          :title="$t('productList.lowerPrice')"
                          v-if="lang == 1"
                        />
                        <img
                          src="../../assets/icon/product-icon/icon_ch_en1.png"
                          class="ch_img"
                          :title="$t('productList.lowerPrice')"
                          v-else
                        />
                      </div>
                      <div
                        class="discount"
                        v-if="isShowDiscount(goods.DiscountRate)"
                      >
                        <img
                          :src="
                            require('../../assets/icon/product-icon/discount_' +
                              (100 - goods.DiscountRate) +
                              '.png')
                          "
                          class="discount_img"
                          :title="$t('productList.discount')"
                          v-if="goods.DiscountRate > 0"
                        />
                      </div>
                      <div class="quality" v-if="goods.isHighQuailty">
                        <img
                          src="../../assets/icon/product-icon/eper_quality_zh.png"
                          class="quality_img"
                          :title="$t('productList.quality')"
                          v-if="lang == 1"
                        />
                        <img
                          src="../../assets/icon/product-icon/eper_quality_en.png"
                          class="quality_img"
                          :title="$t('productList.quality')"
                          v-else
                        />
                      </div>
                      <div class="limittime" v-if="goods.isLimitTime == true">
                        <img
                          :src="
                            require('../../assets/icon/product-icon/time_' +
                              goods.LimitTime +
                              '.png')
                          "
                          :title="$t('productList.limittime')"
                          class="limittime_img"
                        />
                      </div>
                      <div class="exclusive" v-if="goods.isExclusive == true">
                        <img
                          src="../../assets/icon/product-icon/exclusive_zh.png"
                          class="exclusive_img"
                          :title="$t('productList.exclusive')"
                          v-if="lang == 1"
                        />
                        <img
                          src="../../assets/icon/product-icon/exclusive_en.png"
                          class="exclusive_img"
                          :title="$t('productList.exclusive')"
                          v-else
                        />
                      </div>
                      <div class="icon">
                        <img
                          src="../../assets/icon/product-icon/icon_green_vmdpi.png"
                          class="img"
                          :title="$t('productList.vegetarian')"
                          v-if="goods.isvegetarian"
                        />
                        <img
                          src="../../assets/icon/product-icon/icon_green_gmdpi.png"
                          class="img"
                          :title="$t('productList.glutenFree')"
                          v-if="goods.isGlutenFree"
                        />
                        <img
                          src="../../assets/icon/product-icon/icon_green_smdpi.png"
                          class="img"
                          :title="$t('productList.sugerFree')"
                          v-if="goods.isSugerFree"
                        />
                        <img
                          src="../../assets/icon/product-icon/icon_green_biomdpi.png"
                          class="img"
                          :title="lang == 1 ? '' : $t('productList.organic')"
                          v-if="goods.isOrganic"
                        />
                        <img
                          src="../../assets/icon/product-icon/icon_green_hmdpi.png"
                          class="img"
                          :title="$t('productList.muslim')"
                          v-if="goods.isMuslim"
                        />
                        <img
                          src="../../assets/icon/product-icon/icon_tem_4.png"
                          class="img"
                          :title="$t('productList.temperaAttr')"
                          v-if="goods.isTemperaAttr"
                        />
                        <img
                          src="../../assets/icon/product-icon/icon_tem_18.png"
                          class="img"
                          :title="$t('productList.frozen')"
                          v-if="goods.isFrozen"
                        />
                        <img
                          src="../../assets/icon/product-icon/icon_isInstable.png"
                          class="img"
                          :title="$t('productList.instable')"
                          v-if="goods.isInstable"
                        />
                        <img
                          src="../../assets/icon/product-icon/icon_delivery_thirdmdpi.png"
                          class="img"
                          :title="$t('productList.thirdDistribution')"
                          v-if="goods.isThirdDistribution"
                        />
                      </div>
                      <img class="goodsImg" :src="goods.Pic" alt />
                    </div>
                    <div class="product_info">
                      <p class="brandName">{{ goods.BrandName }}</p>
                      <p class="goodsName">{{ goods.ProductName }}</p>
                      <p class="origin">
                        <template v-if="goods.PCountryName">{{ $t("productList.chandi2") }}:{{ goods.PCountryName }}</template>
                      </p>
                      <p class="origin">
                        <template v-if="goods.ProArea">{{ goods.PCountryName ? $t("productList.chandi1") : $t("productList.chandi") }}:{{ goods.ProArea }}</template>
                      </p>
                      <p class="price">￥{{ goods.Price }}</p>
                      <p class="cart" @click.stop="addCart(goods,goods.ProductID,goods.isCanBuy)">
                        <img src="../../assets/icon/shoping-cart.png" alt />
                      </p>
                    </div>
                    <div class="mask" v-if="goods.isCanBuy == false"></div>
                  </div>
                </div>
              </div>
              <div
                class="button"
                v-if="RegularProducts"
                @click.stop="toKeepList()"
              >
                {{ $t("headerNav.Smore") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import filter from "../../plugins/filters";
import md5 from "../../plugins/axios/crypto";
export default {
  name: "headerNav",
  props: {
    showType: Boolean,
    showPerson: Boolean,
  },
  data() {
    return {
      RegularProducts: [],
      trueName: "",
      isPerson: false,
      cusInfo: {},
      token: filter.readData("userInfo")
        ? filter.readData("userInfo").Token
        : "",
      lang: filter.readData("lang"),
      loginDialog: false,
      account: "",
      password: "",
      allinfo: 0,
      offsetTop: 0,
      ispadding: "",
    };
  },
  mounted() {
    if (filter.readData("userInfo")) {
      this.customerInfo();
      this.GetRegularProducts();
    }
    window.addEventListener("scroll", () => {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.ispadding = scrollTop > this.offsetTop + 150 ? true : false;
      // console.log(this.ispadding);
    });
    this.$nextTick(() => {
      this.offsetTop = document.querySelector(".headerNav").offsetTop;
      // console.log("this.offsetTop", this.offsetTop);
    });
  },
  methods: {
    addCart(product, id, canbuy) {
      const _this = this;
      let TempId = "";
      if (this.token) {
        TempId = "";
      } else {
        TempId = localStorage.getItem("TempId");
      }
      _this.$store
        .dispatch("AddToCart", {
          productid: id,
          num: 1,
          cartKind: product.PromotionID ? 0 : 1,
          ckValue: product.PromotionID ? product.PromotionID : "",
          TempId,
          Token: localStorage.getItem("Token")
            ? localStorage.getItem("Token")
            : "",
          PromWebFunctionID: _this.$store.state.PromWebFunctionID
            ? _this.$store.state.PromWebFunctionID
            : ""
        })
        .then(res => {
          if (res.Code == 200) {
            if (canbuy == false) {
              alert("" + this.$t("productList.inventory"));
              return;
            }
            switch (res.Data.Tip) {
              case 104:
                // 超出限购数量
                alert("" + this.$t("addcartMessage.mes4"));
                break;
              case 105:
                // 此商品购买数量不可超过50
                alert("" + this.$t("addcartMessage.mes7"));
                break;
              case 106:
                // 购买数量不能超过促销活动单笔限购数量
                alert("" + this.$t("hint.outBuyNum"));
                break;
              case 107:
                // 购买数量不能超过促销活动单笔限购数量
                alert("" + this.$t("hint.outBuyNum"));
                break;
              case 108:
                // 超出限购数量
                alert("" + this.$t("addcartMessage.mes4"));
                break;
              case 210:
                // 库存不足!
                alert("" + this.$t("productList.inventory"));
                break;
              case 211:
                // 商品不存在
                alert("" + this.$t("addcartMessage.mes8"));
                break;
              case 212:
                // 已过期
                alert("" + this.$t("addcartMessage.mes1"));
                break;
              case 213:
                // 重复参加该促销活动！
                alert("" + this.$t("addcartMessage.mes9"));
                break;
              case 214:
                // 不符合条件！
                alert("" + this.$t("addcartMessage.mes10"));
                break;
              case 215:
                // 已下架
                alert("" + this.$t("addcartMessage.mes11"));
                break;
              case 216:
                // 此商品购买数量不可超过50
                alert("" + this.$t("addcartMessage.mes7"));
                break;
              case 217:
                // 你还未登录
                alert("" + this.$t("headerNav.hint_noLogin"));
                this.$router.replace({
                  path: "/login",
                  query: {
                    redirectUrl: this.$route.fullPath
                  }
                });
                break;
              case 218:
                // 超出限购数量
                alert("" + this.$t("addcartMessage.mes4"));
                break;
              case 220:
                // 您尚未达到会员级别
                alert("" + this.$t("CouponVersion.CouponVersion37"));
                break;
              case 222:
                // 购物车选择赠品
                break;
              case 223:
                //赠品加入购物车不满足条件
                alert("" + this.$t("CouponVersion.CouponVersion32"));
                break;
              case 224:
                //因为优惠券到期导致优惠券下的商品无法加入购物车
                alert("" + this.$t("CouponVersion.CouponVersion33"));
                break;
              case 225:
                //活动限于第xx单用户
                alert(
                  "" +
                    this.$t("CouponVersion.CouponVersion38") +
                    " " +
                    res.Data.ordernum +
                    " " +
                    this.$t("CouponVersion.CouponVersion39")
                );
                break;
            }
            // 212活动过期
            // 217未登录
            // 220有会员限制
            // 108购买的数量超过库存量
            // 106购买数量不能超过促销活动 单笔限购数量
            // 218，104超出限购数量；
            // 215下架；
            // 210缺货库存不足
            _this.GetCartPros(res.Data.Tip);
          }
        });
    },
    GetCartPros(Tip) {
      const _this = this;
      let TempId = "";
      if (this.token) {
        TempId = "";
      } else {
        TempId = localStorage.getItem("TempId");
      }
      _this.$store
        .dispatch("GetCartPros", {
          TempId,
          Token: localStorage.getItem("Token")
            ? localStorage.getItem("Token")
            : ""
        })
        .then(({ Data }) => {
          this.$store.commit("setShopCar", Data);

          if (Tip == 0) {
            this.$store.commit("needShowCartToSeconds", true);
          } else {
            this.$store.commit("needShowCartToSeconds", false);
          }
          this.eventBus.$emit("addCartEvt");
        });
    },
    enter(val) {
      this.timer && clearTimeout(this.timer);
      this.isPerson = val;
    },
    leave(val) {
      this.timer = setTimeout(() => {
        this.isPerson = val;
      }, 200);
    },
    closePerson(val) {
      this.isPerson = val;
    },
    closeLoginDialog() {
      this.loginDialog = false;
    },
    goLogin(val) {
      this.loginDialog = !this.loginDialog;
    },
    forgetPwd() {
      this.$router.push({
        path: "/forgetPwd",
      });
    },
    toRegister() {
      this.$router.push({
        path: "/register",
      });
    },
    // 登录
    Login() {
      // console.log(this);
      if (this.account == "") {
        this.$Message.error("" + this.$t("hint.hint_loginName"));
        return;
      }
      if (this.password == "") {
        this.$Message.error("" + this.$t("hint.hint_pwd"));
        return;
      }
      this.$store
        .dispatch("Login", {
          Name: this.account,
          TempId: localStorage.getItem("TempId")
            ? localStorage.getItem("TempId")
            : "",
          Password: md5.md5String(this.password),
        })
        .then((res) => {
          if (res.Code == 200) {
            this.loginDialog = false;
            localStorage.setItem("userInfo", JSON.stringify(res.Data));
            localStorage.setItem("Token", res.Data.Token);
            localStorage.setItem("InviteCode", res.Data.InviteCode);
            this.$store.commit("set_user_info", res.Data);
            let redirectUrl = this.$route.query.redirectUrl;
            if (redirectUrl && redirectUrl != "") {
              this.$router.replace({ path: redirectUrl });
            } else {
              this.$router.go(0);
            }
          } else if (res.Code == -1) {
            this.$Message.error("" + this.$t("hint.account_error"));
          } else this.$Message.error(res.Message);
        });
    },
    // 获取用户信息
    customerInfo() {
      this.$store
        .dispatch("GetCustomerInfo", {
          Token: localStorage.getItem("Token")
            ? localStorage.getItem("Token")
            : "",
        })
        .then(({ Data }) => {
          this.cusInfo = Data;
          this.allinfo = Data.CashVoucherList + Data.UnreadQuantity;
          this.trueName = Data.TrueName;
        });
    },
    personCenter() {
      if (!this.token) {
        this.$router.push({
          path: "/login",
        });
      } else {
        this.$router.push({
          path: "/user/userInfo",
        });
      }
    },
    referFriend() {
      this.isPerson = false;
      if (!this.token) {
        this.$router.push({
          path: "/login",
        });
      } else {
        this.$router.push({
          path: "/user/invitation",
        });
      }
    },
    goUserCenter(path) {
      if (!this.token) {
        alert("" + this.$t("headerNav.hint_noLogin"));
        this.$router.replace({ path: "/login" });
      } else {
        this.$router.push({
          path,
        });
      }
    },

    goPoint() {
      this.$router.push({
        path: "/user/pointDetail",
      });
    },
    goAccount() {
      this.isPerson = false;
      this.$router.push({
        path: "/user/userInfo",
      });
    },
    toCategory(PropertyIDs) {
      this.$router.replace({
        path: "/category",
        query: {
          PropertyIDs,
          ProductCataID: 0,
          isFromType: false,
          isShowSelect: 1,
          isPattr: true,
          listtype:'p'
        },
      });
    },
    toDetail(goods) {
      // this.$router.push({
      //   path: "/productDetail",
      //   query: { id: goods.ProductID },
      // });
      window.open("/productDetail?id=" + goods.ProductID, "_blank");
    },
    toKeepList() {
      this.$router.push({
        path: "/user/keepList",
      });
    },
    logout() {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("Token");
      localStorage.removeItem("nextShowCouponTemp");
      localStorage.removeItem("InviteCode");
      this.$router.go(0);
    },
    goIndex() {
      window.location.href = "/";
      // this.$router.push({
      //     path: '/'
      // })
    },
    // 获取常购清单
    GetRegularProducts() {
      this.$store
        .dispatch("GetRegularPurchaseProducts", {
          PageIndex: 1,
          PageSize: 2,
          Token: localStorage.getItem("Token")
            ? localStorage.getItem("Token")
            : "",
        })
        .then((res) => {
          if (res.Code == 200) {
            this.RegularProducts = res.Data.List.DateList;
          } else {
          }
        });
    },
    isShowDiscount(discount) {
      let discounts = [
        5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
        95, 100,
      ];
      if (discounts.indexOf(discount) >= 0) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../style/base.scss";
@import "../../style/color.scss";
.pad_btm {
  padding-bottom: 52px;
}
.headerNav {
  padding-top: 40px;
  box-sizing: border-box;
}
.memberInfo {
  overflow: hidden;
}
.all {
  // width: 100%;
  max-width: 1903px;
  margin: 0 auto;
  // background: url("../../assets/activity/tiger_top.jpg") no-repeat center;
  background-size: 100% 100%;
  // background-position: center center;
  .container {
    position: relative;
    width: 1050px;
    //    height: 174px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin: 0 auto;
    text-align: left;
    padding: 27px 0 32px ;
    box-sizing: border-box;
    //    border-bottom: 1px solid red;
    ::after {
      display: none;
    }
    .icons {
      //    border: 1px solid red;
      box-sizing: border-box;
    }
    .clogo {
      width: 193px;
      height: 101px;
      //    border: 1px solid red;
      box-sizing: border-box;
    }
    .cfr {
      //    border: 1px solid red;
      box-sizing: border-box;
    }
    .typeicon {
      padding-top: 70px;
      box-sizing: border-box;
      .img {
        width: 36px;
        height: 36px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 30px;
        cursor: pointer;
      }
    }
    .logo {
      position: absolute;
      //    left: 370px;
      //    top: 27px;
      cursor: pointer;
      .logoimg {
        width: 193px;
        height: 101px;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
      }
    }
    .logo_zh {
      position: absolute;
      left: 441px;
      top: 27px;
      cursor: pointer;
      .logoimg {
        width: 193px;
        height: 101px;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
      }
    }
    .private {
      padding-top: 36px;
      box-sizing: border-box;
      position: relative;
      margin-bottom: -4px;
      .personicon {
        color: $c_000;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
      }
      .item {
        display: inline-block;
        margin-left: 0;
        font-size: 12px;
        text-align: center;
        cursor: pointer;
        margin-left: 34px;
        a {
          color: #515a6e;
        }
        p {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .img {
          height: 43px;
          margin-bottom: 10px;
          display: inline-block;
          vertical-align: middle;
        }
        .person {
          width: 33px;
        }

        .chongzhi {
          width: 40px;
        }
        .refer {
          width: 44px;
        }
      }
      .me {
        position: relative;
      }

      .menum {
        position: absolute;
        top: 0;
        right: 14px;
        color: #fff;
        min-width: 19px;
        height: 19px;
        padding: 0 2px;
        box-sizing: border-box;
        line-height: 19px;
        background: #ff0000;
        border-radius: 20px;
        font-size: 13px;
        text-align: center;
      }
      .arrow_mecn {
        display: block;
        content: "";
        border-width: 5px 5px 5px 5px;
        border-style: solid;
        border-color: $c_6DB transparent transparent transparent;
        position: absolute;
        left: 70px;
        top: 21px;
      }
      .arrow_meen {
        display: block;
        content: "";
        border-width: 5px 5px 5px 5px;
        border-style: solid;
        border-color: $c_6DB transparent transparent transparent;
        position: absolute;
        left: 70px;
        top: 21px;
      }
      .arrow_mefr {
        display: block;
        content: "";
        border-width: 5px 5px 5px 5px;
        border-style: solid;
        border-color: $c_6DB transparent transparent transparent;
        position: absolute;
        left: 70px;
        top: 21px;
      }
      .arrow_nologin {
        display: block;
        content: "";
        border-width: 5px 5px 5px 5px;
        border-style: solid;
        border-color: $c_6DB transparent transparent transparent;
        position: absolute;
        left: 70px;
        top: 21px;
      }
      .login_dialog {
        position: absolute;
        top: 120px;
        width: 259px;
        background: #fff;
        padding: 26px 24px 22px 19px;
        border: 1px solid $c_6DB;
        border-radius: 10px;
        cursor: pointer;
        z-index: 999;
        .login_greenarrow {
          position: absolute;
          left: 79px;
          width: 0px;
          height: 0px;
          content: "";
          top: -20px;
          border-top: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: 10px solid $c_6DB;
          border-left: 10px solid transparent;
        }
        .login_whitearrow {
          position: absolute;
          left: 80px;
          width: 0px;
          height: 0px;
          content: "";
          top: -17px;
          border-top: 9px solid transparent;
          border-right: 9px solid transparent;
          border-bottom: 9px solid #fff;
          border-left: 9px solid transparent;
          z-index: 1;
        }
        .closeLogin {
          width: 20px;
          height: 22px;
          position: absolute;
          right: 5px;
          top: 5px;
          img {
            width: 20px;
            height: 20px;
          }
        }
        .login-account {
          width: 100%;
          height: 26px;
          font-size: 12px;
          border: 1px solid #ccc;
          margin-bottom: 5px;
          padding-left: 10px;
          box-sizing: border-box;
          color: $c_000;
        }
        .login-password {
          width: 100%;
          height: 26px;
          font-size: 12px;
          border: 1px solid #ccc;
          margin-bottom: 6px;
          padding-left: 10px;
          box-sizing: border-box;
          color: $c_000;
        }
        .forgetPwd {
          width: 100%;
          text-align: right;
          font-size: 12px;
          color: $c_6DB;
          text-decoration: underline;
          z-index: 999;
        }
        .loginBtn {
          margin-top: 6px;
          width: 100%;
          height: 26px;
          text-align: center;
          line-height: 26px;
          border-radius: 13px;
          background: $c_6DB;
          color: #fff;
          font-size: 12px;
        }
        .registerBtn {
          margin-top: 3px;
          width: 100%;
          height: 26px;
          text-align: center;
          line-height: 26px;
          border-radius: 13px;
          background: $c_000;
          color: #fff;
          font-size: 12px;
        }
      }
      .login_dialog_en {
        position: absolute;
        left: -43px;
        top: 120px;
        width: 259px;
        background: #fff;
        padding: 26px 24px 22px 19px;
        border: 1px solid $c_6DB;
        border-radius: 10px;
        cursor: pointer;
        z-index: 999;
        .login_greenarrow {
          position: absolute;
          left: 123px;
          width: 0px;
          height: 0px;
          content: "";
          top: -20px;
          border-top: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: 10px solid $c_6DB;
          border-left: 10px solid transparent;
        }
        .login_whitearrow {
          position: absolute;
          left: 124px;
          width: 0px;
          height: 0px;
          content: "";
          top: -17px;
          border-top: 9px solid transparent;
          border-right: 9px solid transparent;
          border-bottom: 9px solid #fff;
          border-left: 9px solid transparent;
          z-index: 1;
        }
        .closeLogin {
          width: 20px;
          height: 22px;
          position: absolute;
          right: 5px;
          top: 5px;
          img {
            width: 20px;
            height: 20px;
          }
        }
        .login-account {
          width: 100%;
          height: 26px;
          font-size: 12px;
          border: 1px solid #ccc;
          margin-bottom: 5px;
          padding-left: 5px;
          box-sizing: border-box;
          color: $c_000;
          font-family: EperFontLight;
        }
        .login-password {
          width: 100%;
          height: 26px;
          font-size: 12px;
          border: 1px solid #ccc;
          margin-bottom: 6px;
          padding-left: 5px;
          box-sizing: border-box;
          color: $c_000;
          font-family: EperFontLight;
        }
        .forgetPwd {
          width: 100%;
          text-align: right;
          font-size: 12px;
          color: $c_6DB;
          text-decoration: underline;
          z-index: 999;
          font-family: EperFontLight;
        }
        .loginBtn {
          margin-top: 10px;
          width: 100%;
          height: 26px;
          text-align: center;
          line-height: 26px;
          border-radius: 13px;
          background: $c_6DB;
          color: #fff;
          font-size: 12px;
        }
        .registerBtn {
          margin-top: 6px;
          width: 100%;
          height: 26px;
          text-align: center;
          line-height: 26px;
          border-radius: 13px;
          background: $c_000;
          color: #fff;
          font-size: 12px;
        }
      }
      .login_dialog_fr {
        position: absolute;
        top: 120px;
        width: 259px;
        background: #fff;
        padding: 26px 24px 22px 19px;
        border: 1px solid $c_6DB;
        border-radius: 10px;
        cursor: pointer;
        z-index: 999;
        .login_greenarrow {
          position: absolute;
          left: 137px;
          width: 0px;
          height: 0px;
          content: "";
          top: -20px;
          border-top: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: 10px solid $c_6DB;
          border-left: 10px solid transparent;
        }
        .login_whitearrow {
          position: absolute;
          left: 138px;
          width: 0px;
          height: 0px;
          content: "";
          top: -17px;
          border-top: 9px solid transparent;
          border-right: 9px solid transparent;
          border-bottom: 9px solid #fff;
          border-left: 9px solid transparent;
          z-index: 1;
        }
        .closeLogin {
          width: 20px;
          height: 22px;
          position: absolute;
          right: 10px;
          top: 5px;
          img {
            width: 20px;
            height: 20px;
          }
        }
        .login-account {
          width: 100%;
          height: 26px;
          font-size: 12px;
          border: 1px solid #ccc;
          margin-bottom: 5px;
          padding-left: 5px;
          box-sizing: border-box;
          color: $c_000;
        }
        .login-password {
          width: 100%;
          height: 26px;
          font-size: 12px;
          border: 1px solid #ccc;
          margin-bottom: 6px;
          padding-left: 5px;
          box-sizing: border-box;
          color: $c_000;
        }
        .forgetPwd {
          width: 100%;
          text-align: right;
          font-size: 12px;
          color: $c_6DB;
          text-decoration: underline;
          z-index: 999;
        }
        .loginBtn {
          margin-top: 6px;
          width: 100%;
          height: 26px;
          text-align: center;
          line-height: 26px;
          border-radius: 13px;
          background: $c_6DB;
          color: #fff;
          font-size: 12px;
        }
        .registerBtn {
          margin-top: 3px;
          width: 100%;
          height: 26px;
          text-align: center;
          line-height: 26px;
          border-radius: 13px;
          background: $c_000;
          color: #fff;
          font-size: 12px;
        }
      }
      .quick_person {
        position: absolute;
        top: 132px;
        right: 177px;
        padding: 20px 20px 13px 20px;
        width: 404px;
        border: 1px solid $c_6DB;
        border-radius: 14px 0 14px 14px;
        background: #fff;
        z-index: 9999;
        letter-spacing: 3px;
        .close {
          position: absolute;
          top: 4px;
          right: 4px;
          width: 20px;
          height: 20px;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .grade {
          font-size: 17px;
          .gradeimg_3 {
            width: 20px;
            height: 20px;
            display: inline-block;
            vertical-align: middle;
          }
          .gradeimg_5,
          .gradeimg_9 {
            width: 20px;
            height: 17px;
            display: inline-block;
            vertical-align: middle;
          }
        }
        .num {
          color: $c_6DB;
          text-decoration: underline;
          cursor: pointer;
          letter-spacing: 0px;
        }
        .points {
          font-size: 14px;
        }
        .account {
          font-size: 14px;
          margin-bottom: 28px;
          .logout {
            font-size: 17px;
            color: $c_000;
            font-weight: bold;
            text-decoration: underline;
            cursor: pointer;
          }
        }
        .personal {
          padding-top: 20px;
          margin-bottom: 22px;
          overflow: hidden;
          .item_pen2 {
            width: 116px;
            margin: 0 0 0 0px;
          }
          .item_pen5 {
            width: 116px;
            margin: 0 0 0 0px;
          }
          .item_pcn2 {
            margin: 0 10px;
          }
          .item_pcn5 {
            margin: 0 10px;
          }
          .item_p {
            text-align: center;
            font-size: 14px;
            width: 120px;
            height: 80px;
            box-sizing: border-box;
            position: relative;
            .letterNum {
              position: absolute;
              top: -5px;
              right: 24px;
              color: #fff;
              min-width: 17px;
              height: 17px;
              padding: 0 2px;
              line-height: 17px;
              background: #ff0000;
              border-radius: 20px;
              font-size: 14px;
              text-align: center;
            }
            .letterNum.zh {
              right: 30px;
            }
            .letterNum.fr {
              right: 14px;
            }
            img {
              display: inline-block;
              vertical-align: middle;
            }
            span {
              display: block;
              @include ellipsisMore(2);
            }
            .refer {
              width: 45px;
              height: 45px;
            }
            .letter {
              width: 45px;
              height: 45px;
            }
            .like {
              width: 45px;
              height: 45px;
            }
            .person {
              width: 45px;
              height: 45px;
            }
            .order {
              width: 45px;
              height: 45px;
            }
            .wallet {
              width: 45px;
              height: 45px;
            }
            a:hover {
              span {
                color: $c_6DB;
              }
              .letterNum {
                color: $c_fff;
              }
            }
          }
        }
        .necessity {
          clear: both;
          .title {
            width: 100%;
            border-top: 1px solid #231f20;
            position: relative;
            margin-bottom: 19px;
            .text {
              display: inline-block;
              position: absolute;
              left: 140px;
              top: -11px;
              background: #fff;
              font-size: 14px;
              color: $c_000;
              padding: 0 10px;
              box-sizing: border-box;
            }
          }
          .goods {
            margin-bottom: 10px;
            overflow: hidden;
            .goodsItem {
              position: relative;
              width: 177px;
              padding-bottom: 10px;
              box-sizing: border-box;
              background: #f9f9f9;
              cursor: pointer;
              .icon {
                position: absolute;
                right: 0;
                top: 0;
                .img {
                  width: 27px;
                  height: 27px;
                  float: right;
                  margin: 6px 6px 0 0;
                }
              }
              .pic {
                width: 100%;
                height: 169px;
                position: relative;
                .low-price {
                  position: absolute;
                  left: 0;
                  top: 0;
                  z-index: 77;
                  .ch_img {
                    width: 55px;
                    height: auto;
                  }
                }
                .discount {
                  position: absolute;
                  right: 10px;
                  bottom: 30px;
                  height: 30px;
                  z-index: 77;
                  .discount_img {
                    width: 60px;
                    height: 30px;
                  }
                }
                .quality {
                  position: absolute;
                  width: 160px;
                  height: 23px;
                  bottom: 0;
                  left: 50%;
                  z-index: 77;
                  margin-left: -75px;
                  .quality_img {
                    width: 160px;
                    height: auto;
                  }
                }
                .limittime {
                  position: absolute;
                  left: 0;
                  bottom: 30px;
                  height: 21px;
                  z-index: 77;
                  .limittime_img {
                    width: 80px;
                    height: 21px;
                  }
                }
                .exclusive {
                  position: absolute;
                  right: 0;
                  bottom: 30px;
                  height: 46px;
                  z-index: 76;
                  .exclusive_img {
                    width: 100px;
                    height: 46px;
                  }
                }
                .goodsImg {
                  width: 100%;
                  height: 169px;
                }
              }
              .product_info {
                flex: 1;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                .brandName {
                  font-size: 14px;
                  padding: 0 14px;
                  color: #231f20;
                  // margin-bottom: 10px;
                  font-family: "EperFontLight";
                  box-sizing: border-box;
                  font-weight: 600;
                  width: 100%;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  letter-spacing: 0px;
                }
              }
              .mask {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                z-index: 10;
                background: $c_0fff;
              }
              .goodsName {
                font-size: 14px;
                padding: 0 14px;
                color: $c_000;
                @include ellipsisMore(2);
                box-sizing: border-box;
                margin-bottom: 10px;
              }
              .origin {
                font-size: 12px;
                padding: 0 14px;
                color: $c_000;
                box-sizing: border-box;
                height: 18px;
                line-height: 18px;
              }
              .price {
                color: $c_6DB;
                font-size: 14px;
                padding: 0 14px;
                box-sizing: border-box;
                letter-spacing: 0px;
              }
              .cart {
                width: 30px;
                height: 30px;
                position: absolute;
                right: 12px;
                bottom: 6px;
                img {
                  width: 30px;
                  height: auto;
                }
              }
            }
            .goodsItem:nth-child(1) {
              margin-right: 6px;
            }
          }
        }
        .button {
          margin: 0 auto;
          width: 232px;
          height: 24px;
          text-align: center;
          line-height: 24px;
          color: $c_6DB;
          font-size: 12px;
          border: 1px solid $c_6DB;
          border-radius: 12px;
          cursor: pointer;
          @include ellipsisMore(1);
        }
      }
      .quick_person_en {
        position: absolute;
        top: 132px;
        right: 260px;
        padding: 15px 21px 13px 20px;
        width: 404px;
        border: 1px solid $c_6DB;
        border-radius: 14px 0 14px 14px;
        background: #fff;
        z-index: 9999;
        .close {
          position: absolute;
          top: 4px;
          right: 4px;
          width: 20px;
          height: 20px;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .memberInfo {
          font-family: "EperFontLight";
          overflow: hidden;
        }
        .grade {
          font-size: 14px;
          .gradeimg_3 {
            width: 20px;
            height: 20px;
            display: inline-block;
            vertical-align: middle;
          }
          .gradeimg_5,
          .gradeimg_9 {
            width: 20px;
            height: 17px;
            display: inline-block;
            vertical-align: middle;
          }
          .level-name {
            display: inline-block;
            vertical-align: middle;
          }
        }
        .num {
          color: $c_6DB;
          cursor: pointer;
          border-bottom: 1px $c_6DB solid;
        }
        .points {
          font-size: 14px;
        }
        .account {
          font-size: 14px;
          margin-bottom: 28px;
          .logout {
            height: 20px;
            font-size: 14px;
            color: $c_000;
            border-bottom: 1px $c_000 solid;
            cursor: pointer;
            font-family: "EperFontBold";
          }
        }
        .personal {
          padding-top: 20px;
          margin-bottom: 22px;
          overflow: hidden;
          .item_pen2 {
            width: 116px;
            margin: 0 0 0 0px;
          }
          .item_pen5 {
            width: 116px;
            margin: 0;
          }
          .item_pcn2 {
            margin: 0 80px;
          }
          .item_pcn5 {
            margin: 0 65px;
          }
          .item_p {
            text-align: center;
            font-size: 14px;
            width: 120px;
            height: 90px;
            box-sizing: border-box;
            position: relative;
            a {
              width: 100%;
              height: 100%;
              display: block;
            }
            .letterNum {
              position: absolute;
              top: -5px;
              right: 28px;
              color: #fff;
              min-width: 17px;
              height: 17px;
              padding: 0 2px;
              line-height: 17px;
              background: #ff0000;
              border-radius: 20px;
              font-size: 14px;
              text-align: center;
            }
            .letterNum.zh {
              right: -5px;
            }
            .letterNum.fr {
              right: 14px;
            }
            img {
              display: inline-block;
              vertical-align: middle;
            }
            span {
              display: block;
              font-size: $font_base;
              @include ellipsisMore(2);
              margin-top: 5px;
              font-family: "EperFontLight";
            }
            .refer {
              display: block;
              margin: 0px auto;
              width: 45px;
              height: 45px;
            }
            .letter {
              width: 45px;
              height: 45px;
            }
            .like {
              width: 45px;
              height: 45px;
            }
            .person {
              width: 45px;
              height: 45px;
            }
            .order {
              width: 45px;
              height: 45px;
            }
            .wallet {
              width: 45px;
              height: 45px;
            }
            a:hover {
              span {
                color: $c_6DB;
              }
              .letterNum {
                color: $c_fff;
              }
            }
          }
        }
        .necessity {
          .title {
            width: 100%;
            border-top: 1px solid $c_000;
            position: relative;
            margin-bottom: 19px;
            .text {
              display: inline-block;
              position: absolute;
              left: 123px;
              top: -13px;
              background: #fff;
              font-size: 17px;
              color: $c_000;
              padding: 0 10px;
              box-sizing: border-box;
            }
          }
          .goods {
            margin-bottom: 10px;
            overflow: hidden;
            .goodsItem {
              position: relative;
              width: 177px;
              padding-bottom: 10px;
              box-sizing: border-box;
              background: #f9f9f9;
              cursor: pointer;
              .icon {
                position: absolute;
                right: 0;
                top: 0;
                .img {
                  width: 27px;
                  height: 27px;
                  float: right;
                  margin: 6px 6px 0 0;
                }
              }
              .pic {
                width: 100%;
                height: 169px;
                position: relative;
                .low-price {
                  position: absolute;
                  left: 0;
                  top: 0;
                  z-index: 77;
                  .ch_img {
                    width: 55px;
                    height: auto;
                  }
                }
                .discount {
                  position: absolute;
                  right: 10px;
                  bottom: 30px;
                  height: 30px;
                  z-index: 77;
                  .discount_img {
                    width: 60px;
                    height: 30px;
                  }
                }
                .quality {
                  position: absolute;
                  width: 160px;
                  height: 23px;
                  bottom: 0;
                  left: 50%;
                  z-index: 77;
                  margin-left: -75px;
                  .quality_img {
                    width: 160px;
                    height: auto;
                  }
                }
                .limittime {
                  position: absolute;
                  left: 0;
                  bottom: 30px;
                  height: 21px;
                  z-index: 77;
                  .limittime_img {
                    width: 80px;
                    height: 21px;
                  }
                }
                .exclusive {
                  position: absolute;
                  right: 0;
                  bottom: 30px;
                  height: 46px;
                  z-index: 76;
                  .exclusive_img {
                    width: 100px;
                    height: 46px;
                  }
                }
                .goodsImg {
                  width: 100%;
                  height: 169px;
                }
              }
              .product_info {
                flex: 1;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                .brandName {
                  font-size: 14px;
                  padding: 0 14px;
                  color: #231f20;
                  // margin-bottom: 10px;
                  font-family: "EperFontLight";
                  box-sizing: border-box;
                  font-weight: 600;
                  width: 100%;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  letter-spacing: 0px;
                }
              }
              .mask {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                z-index: 10;
                background: $c_0fff;
              }
              .goodsName {
                font-size: 14px;
                padding: 0 14px;
                color: $c_000;
                @include ellipsisMore(2);
                box-sizing: border-box;
                margin-bottom: 10px;
                font-family: "EperFontLight";
              }
              .origin {
                font-size: 12px;
                padding: 0 14px;
                color: $c_000;
                box-sizing: border-box;
                font-family: "EperFontLight";
                height: 18px;
                line-height: 18px;
              }
              .price {
                color: $c_6DB;
                font-size: 14px;
                padding: 0 14px;
                box-sizing: border-box;
                margin-left: -1px;
              }
              .cart {
                width: 30px;
                height: 30px;
                position: absolute;
                right: 12px;
                bottom: 6px;
                img {
                  width: 30px;
                  height: auto;
                }
              }
            }
            .goodsItem:nth-child(1) {
              margin-right: 6px;
            }
          }
        }
        .button {
          margin: 0 auto;
          width: 179px;
          height: 36px;
          text-align: center;
          color: #231f20;
          font-size: 16px;
          line-height: 34px;
          border: 1px solid #231f20;
          border-radius: 20px;
          cursor: pointer;
          @include ellipsisMore(1);
        }
      }
      .quick_person_fr {
        position: absolute;
        top: 132px;
        right: 274px;
        padding: 30px 21px 13px 20px;
        width: 404px;
        border: 1px solid $c_6DB;
        border-radius: 14px 0 14px 14px;
        background: #fff;
        z-index: 9999;
        .close {
          position: absolute;
          top: 4px;
          right: 4px;
          width: 20px;
          height: 20px;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .memberInfo {
          font-family: "EperFontLight";
          overflow: hidden;
        }
        .grade {
          font-size: 17px;
          .gradeimg_3 {
            width: 20px;
            height: 20px;
            display: inline-block;
            vertical-align: middle;
          }
          .gradeimg_5,
          .gradeimg_9 {
            width: 20px;
            height: 17px;
            display: inline-block;
            vertical-align: middle;
          }
        }
        .num {
          color: $c_6DB;
          text-decoration: underline;
          cursor: pointer;
        }
        .points {
          font-size: 14px;
        }
        .account {
          font-size: 14px;
          margin-bottom: 28px;
          .logout {
            font-size: $font_md;
            color: $c_000;
            text-decoration: underline;
            cursor: pointer;
            font-family: "EperFontBold";
          }
        }
        .personal {
          margin-bottom: 22px;
          overflow: hidden;
          .item_pen2 {
            width: 116px;
            margin: 0 0 0 0px;
          }
          .item_pen5 {
            width: 116px;
            margin: 0 0 0 0px;
          }
          .item_pcn2 {
            margin: 0 80px;
          }
          .item_pcn5 {
            margin: 0 65px;
          }
          .item_p {
            text-align: center;
            font-size: 14px;
            width: 120px;
            height: 80px;
            box-sizing: border-box;
            position: relative;
            font-family: "EperFontLight";
            .letterNum {
              position: absolute;
              top: 0;
              right: 24px;
              color: #fff;
              min-width: 17px;
              height: 17px;
              padding: 0 2px;
              line-height: 17px;
              background: #ff0000;
              border-radius: 20px;
              font-size: 14px;
              text-align: center;
            }
            .letterNum.zh {
              right: -5px;
            }
            .letterNum.fr {
              right: 30px;
            }
            img {
              display: inline-block;
              vertical-align: middle;
            }
            span {
              display: block;
              @include ellipsisMore(2);
              line-height: 15px;
              padding-top: 6px;
            }
            .refer {
              width: 45px;
              height: 45px;
            }
            .letter {
              width: 45px;
              height: 45px;
            }
            .like {
              width: 45px;
              height: 45px;
            }
            .person {
              width: 45px;
              height: 45px;
            }
            .order {
              width: 45px;
              height: 45px;
            }
            .wallet {
              width: 45px;
              height: 45px;
            }
            a:hover {
              span {
                color: $c_6DB;
              }
              .letterNum {
                color: $c_fff;
              }
            }
          }
        }
        .necessity {
          .title {
            width: 100%;
            border: 1px solid $c_000;
            position: relative;
            margin-bottom: 19px;
            .text {
              display: inline-block;
              position: absolute;
              left: 105px;
              top: -11px;
              background: #fff;
              font-size: 14px;
              color: $c_000;
              padding: 0 10px;
              box-sizing: border-box;
            }
          }
          .goods {
            margin-bottom: 10px;
            overflow: hidden;
            .goodsItem {
              position: relative;
              width: 177px;
              padding-bottom: 10px;
              box-sizing: border-box;
              background: #f9f9f9;
              cursor: pointer;
              .icon {
                position: absolute;
                right: 0;
                top: 0;
                .img {
                  width: 27px;
                  height: 27px;
                  float: right;
                  margin: 6px 6px 0 0;
                }
              }
              .pic {
                width: 100%;
                height: 169px;
                position: relative;
                .low-price {
                  position: absolute;
                  left: 0;
                  top: 0;
                  z-index: 77;
                  .ch_img {
                    width: 55px;
                    height: auto;
                  }
                }
                .discount {
                  position: absolute;
                  right: 10px;
                  bottom: 30px;
                  height: 30px;
                  z-index: 77;
                  .discount_img {
                    width: 60px;
                    height: 30px;
                  }
                }
                .quality {
                  position: absolute;
                  width: 160px;
                  height: 23px;
                  bottom: 0;
                  left: 50%;
                  z-index: 77;
                  margin-left: -75px;
                  .quality_img {
                    width: 160px;
                    height: auto;
                  }
                }
                .limittime {
                  position: absolute;
                  left: 0;
                  bottom: 30px;
                  height: 21px;
                  z-index: 77;
                  .limittime_img {
                    width: 80px;
                    height: 21px;
                  }
                }
                .exclusive {
                  position: absolute;
                  right: 0;
                  bottom: 30px;
                  height: 46px;
                  z-index: 76;
                  .exclusive_img {
                    width: 100px;
                    height: 46px;
                  }
                }
                .goodsImg {
                  width: 100%;
                  height: 169px;
                }
              }
              .product_info {
                flex: 1;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                .brandName {
                  font-size: 14px;
                  padding: 0 14px;
                  color: #231f20;
                  // margin-bottom: 10px;
                  font-family: "EperFontLight";
                  box-sizing: border-box;
                  font-weight: 600;
                  width: 100%;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  letter-spacing: 0px;
                }
              }
              .mask {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                z-index: 10;
                background: $c_0fff;
              }
              .goodsName {
                font-size: 14px;
                padding: 0 14px;
                color: $c_000;
                @include ellipsisMore(2);
                box-sizing: border-box;
                margin-bottom: 10px;
                font-family: "EperFontLight";
              }
              .origin {
                font-size: 12px;
                padding: 0 14px;
                color: $c_000;
                box-sizing: border-box;
                font-family: "EperFontLight";
                height: 18px;
                line-height: 18px;
              }
              .price {
                color: $c_6DB;
                font-size: 14px;
                padding: 0 14px;
                box-sizing: border-box;
              }
              .cart {
                width: 30px;
                height: 30px;
                position: absolute;
                right: 12px;
                bottom: 6px;
                img {
                  width: 30px;
                  height: auto;
                }
              }
            }
            .goodsItem:nth-child(1) {
              margin-right: 6px;
            }
          }
        }
        .button {
          margin: 0 auto;
          width: 232px;
          height: 24px;
          text-align: center;
          line-height: 24px;
          color: $c_6DB;
          font-size: 12px;
          border: 1px solid $c_6DB;
          border-radius: 12px;
          cursor: pointer;
          @include ellipsisMore(1);
        }
      }
      .green_arrow {
        position: absolute;
        right: -1px;
        width: 0px;
        width: 29px;
        height: 15px;
        top: -15px;
        background: #ffffff;

        img {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0px;
          top: 0px;
        }
        // border-top: 10px solid transparent;
        // border-right: 10px solid transparent;
        // border-bottom: 10px solid $c_6DB;
        // border-left: 10px solid transparent;
      }
      .white_arrow {
        position: absolute;
        right: 0px;
        width: 0px;
        height: 0px;
        content: "";
        top: -17px;
        border-top: 9px solid transparent;
        border-right: 9px solid transparent;
        border-bottom: 9px solid #fff;
        border-left: 9px solid transparent;
        z-index: 1;
      }
      .green_arrow.en {
        left: 80px;
      }
      .white_arrow.en {
        left: 81px;
      }
      .green_arrow.fr {
        left: 55px;
      }
      .white_arrow.fr {
        left: 56px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/headerNav.vue